import { FC } from 'react';
import { IonSegment, IonSegmentButton } from '@ionic/react';
import { AllieSegmentIconProps } from './SegmentIcon.types';
import { StyledSegmentContainer } from './SegmentIcon.styles';
import { AlliePortalTooltip } from '../PortalTooltip';

export const AllieSegmentIcon: FC<AllieSegmentIconProps> = ({ options, ...props }) => (
  <IonSegment selectOnFocus swipeGesture={false} {...props}>
    <StyledSegmentContainer>
      {options.map(({ icon, tooltip, tooltipSide, tooltipAlignment, ...option }) => {
        const button = (
          <IonSegmentButton key={option.value} {...option}>
            {icon}
          </IonSegmentButton>
        );

        return tooltip ? (
          <AlliePortalTooltip
            key={option.value}
            content={tooltip}
            side={tooltipSide}
            alignment={tooltipAlignment}
          >
            {button}
          </AlliePortalTooltip>
        ) : (
          button
        );
      })}
    </StyledSegmentContainer>
  </IonSegment>
);
